import React, { useState, useEffect } from 'react';
import { GoogleMap, Marker, Autocomplete } from '@react-google-maps/api';
import { useGoogleMapsLoader } from '../../utility/googleApiLoader';

export default function GmapsKeyTester() {
  const [mapCenter, setMapCenter] = useState({ lat: 32.0853, lng: 34.7818 }); // Default to Tel Aviv
  const [address, setAddress] = useState('');
  const [status, setStatus] = useState('');

  const { isLoaded, loadError } = useGoogleMapsLoader();

  useEffect(() => {
    if (loadError) {
      setStatus(`Error: ${loadError.message}`);
      console.error('Google Maps load error:', loadError);
    } else if (isLoaded) {
      setStatus('API key is working! Map loaded successfully');
      console.log('Google Maps loaded successfully');
    }
  }, [isLoaded, loadError]);

  const onPlaceChanged = (autocomplete) => {
    const place = autocomplete.getPlace();
    if (place.geometry) {
      setMapCenter({
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng()
      });
      setAddress(place.formatted_address);
    }
  };

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <h2>Google Maps Key Test Page</h2>
      <p>Environment: {process.env.NODE_ENV}</p>
      <p>API Key: {process.env.REACT_APP_GMAPS_KEY ? '****' + process.env.REACT_APP_GMAPS_KEY.slice(-4) : 'NOT SET'}</p>
      
      <div style={{ 
        padding: '10px', 
        margin: '10px 0', 
        backgroundColor: loadError ? '#ffebee' : '#e8f5e9',
        borderRadius: '4px'
      }}>
        <strong>Status:</strong> {status || 'Loading...'}
      </div>

      {isLoaded && (
        <>
          <Autocomplete
            onLoad={autocomplete => {
              autocomplete.setFields(['formatted_address', 'geometry']);
              autocomplete.addListener('place_changed', () => onPlaceChanged(autocomplete));
            }}
          >
            <input
              type="text"
              placeholder="Search for an address in Israel..."
              style={{
                width: '100%',
                padding: '10px',
                marginBottom: '10px',
                border: '1px solid #ddd'
              }}
            />
          </Autocomplete>
          
          <GoogleMap
            mapContainerStyle={{ height: '400px', width: '100%' }}
            center={mapCenter}
            zoom={15}
          >
            <Marker position={mapCenter} />
          </GoogleMap>
          
          {address && (
            <div style={{ marginTop: '10px' }}>
              <strong>Selected Address:</strong> {address}
            </div>
          )}
        </>
      )}
    </div>
  );
}